<script>
// import axios from "axios";
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Fields from "@/helpers/fields";
import axios from "axios";
import Vue from "vue";
import VueAxios from "vue-axios";
import VueSweetalert2 from 'vue-sweetalert2';
// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);

Vue.use(VueAxios, axios);

import { todoMethods, todoComputed } from "@/state/helpers";

import { tableData } from "../dataAdvancedtable";
import moment from 'moment';

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Empresas, instituciones o dependencias",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      // ************************************** Link
      tableData: tableData,
      title: "Empresas, Instituciones o Dependencias",
      items: [
        {
          text: "Escritorio",
          href: "/",
        },
        {
          text: "Empresas, instituciones o dependencias",
          active: true,
        },
      ],
      tableEnterprise: [],
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      todocurrentPage: 1,
      perPage: 10,
      todoperPage: 10,
      pageOptions: [10, 25, 50, 100],
      todoOptions: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortBy: "age",
      sortDesc: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#FFFFFF",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,
      empresasFields: Fields.empresasFields,
    };
  },

  filters: {
    moment: function (date) {
      if (date) {
        moment.locale('es');
        return moment(date).format('LL');
      }
    }
  },

  computed: {
    ...todoComputed,
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },

    /**
     * Todo list of records
     */
    todoList() {
      return this.todos.length;
    },
  },

  mounted() {
    this.getTable();

    this.fetchTodos();
    // Set the initial number of items
    this.totalRows = this.tableData.length;

    this.todoTotalRows = this.todos.length;

    // Set the class table-light to the thead element
    document.getElementById("b_table_enterprices").firstElementChild.classList.add("table-light");
  },

  methods: {
    getTable() {
      axios.get("/empresas").then((response) => {
        this.response = response.data.data;
        this.tableEnterprise = response.data.data;
        console.log(response);
      });
    },
    ...todoMethods,

    handleEdit(id_empresa) {
      this.$router.push({
        name: "ActualizaEmpresa",
        params: {
          id_empresa: id_empresa,
        },
      });
    },
    handleDelete(id_empresa) {
      this.$swal({
        title: "¿Estas seguro de borrar?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, borrar",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          axios.put("/empresas", { id_empresa: id_empresa, active: "0" })
          console.log(id_empresa)
            .then((res) => {
              const { response = "" } = res.data;
              if (response === true) {
                this.$swal(
                  "Eliminado",
                  "Empresa eliminada correctamente",
                  "success"
                );
                this.$router.push({ name: "Empresas" });
                this.getTable();
              } else {
                this.$swal("Alertas", "No se pudo eliminar", "warning");
              }
            })
            .catch((err) => {
              console.log(err);
              this.$swal("Error", "Ocurrio un error", "error");
            });
        }
      });
    },
    handleMark(id){
      this.$swal({
        title: "¿Marcar como entregadas?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, entregar",
        cancelButtonText: "No",
      }).then((result) => {
        console.log('aqui andamos')
        if (result.isConfirmed) {
          axios.put("/empresas", { id_empresa: id, estatus_entrega: 1 })
            .then((res) => {
              const { response = "" } = res.data;
              if (response === true) {
                this.$swal(
                  "Entrega",
                  "Tarjetas entregadas correctamente",
                  "success"
                );
                this.$router.push({ name: "Empresas" });
                this.getTable();
              } else {
                this.$swal("Alertas", "No se pudo entregar", "warning");
              }
            })
            .catch((err) => {
              console.log(err);
              this.$swal("Error", "Ocurrio un error", "error");
            });
        }
      });
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    todoFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.todoTotalRows = filteredItems.length;
      this.todocurrentPage = 1;
    },

    getColor(estado) {
      if (estado == "Activo") return "red";
      else return "green";
    },

    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <!-- end row -->
    <div class="row mb-6">
      <div class="col-lg-12">
        <v-card>
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <h4 class="card-title mb-4">Registro de empresas, instituciones o dependencias</h4>
              </div>
              <div class="col-sm-12 col-md-6 text-md-end">
                <router-link to="/NuevaEmpresa">
                  <v-btn
                    depressed
                    color="primary"
                    type="button"
                    id="button-addon2"
                  >
                    Nuevo registro
                  </v-btn>
                </router-link>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Ver
                    <v-divider class="mx-1" inset vertical></v-divider>
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                    <v-divider class="mx-1" inset vertical></v-divider>

                    registros
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Buscar:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Buscar..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- tableEnterprise table -->
            <b-table
              id="b_table_enterprices"
              :fields="empresasFields"
              :items="tableEnterprise"
              :filter="filter"
              :current-page="currentPage"
              :per-page="perPage"
            >
              <template #cell(id_empresa)="data">
                <a href="javascript: void(0);" class="text-body fw-bold">
                  {{ data.item.id_evento }}
                </a>
              </template>
              <template #cell(semaforo)="data">
                <span
                  class="badge badge-pill bg-success font-size-11"
                  :class="{
                    'bg-success': `${data.item.semaforo}` === 'Verde',
                    'bg-warning': `${data.item.semaforo}` === 'Amarillo',
                    'bg-danger': `${data.item.semaforo}` === 'Rojo',
                  }"
                  >{{ data.item.estatus_entrega == 1 ? 'Entregado' : data.item.semaforo }}</span
                >
              </template>
              <template #cell(folio_inicio)="data">
                <span>
                  {{`${data.item.folio_inicio} - ${data.item.folio_fin}`}}
                </span>
              </template>
              <template #cell(fecha_entrega)="data">
                {{data.item.fecha_entrega | moment}}
              </template>
              <template #cell(edit)="data">
                <v-btn
                  icon
                  small
                  @click="handleEdit(data.item.id_empresa)"
                >
                  <i style="color: #09a5c7" class="bx bxs-pencil"></i>
                </v-btn>
                <v-btn
                  icon
                  small
                  @click="handleMark(data.item.id_empresa)"
                >
                  <i style="color: #60277d" class="bx bxs-bookmark"></i>
                </v-btn>
                <v-btn
                  icon
                  small
                  @click="handleDelete(data.item.id_empresa)"
                >
                  <i style="color: #e73484" class="bx bx-trash"></i>
                </v-btn>
              </template>
            </b-table>
          </div>
          <div class="row mt-4">
            <div class="col-sm-12 col-md-6">
              <v-divider class="mx-2" inset vertical></v-divider>
              Mostrando {{ perPage > tableEnterprise.length ? tableEnterprise.length : perPage }} de {{ tableEnterprise.length }} registros
            </div>
            <div class="col-sm-12 col-md-6 text-md-end pr-10">
              <b-pagination
                align="right"
                v-model="currentPage"
                :total-rows="tableEnterprise.length"
                :per-page="perPage"
                first-text="Primera"
                prev-text="Anterior"
                next-text="Siguiente"
                last-text="Última"
              ></b-pagination>
            </div>
          </div>
        </v-card>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
